var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body"},[_c('el-alert',{attrs:{"closable":false}},[_vm._v("O QRCODE para pagamento do Pix será gerado na próxima tela")]),_c('img',{attrs:{"src":"/img/payment/qrcode.png","width":"200"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }